/* MUI Imports */

import {
  Box,
  Button,
  Dialog,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import FavoriteIcon from '@mui/icons-material/Favorite';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';

/* App Imports */

import { TableHeaderCell } from '../../../styles/miscStyles';
import { StyledRatingHearts } from '../../../styles/miscStyles';

const HeartsModal = ({ open, handleClose, hearts, max }) => {
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby='modal-modal-title'
      aria-describedby='modal-modal-description'
      fullWidth
    >
      <Box p={2}>
        <Box>
          <Typography id='modal-modal-title' variant='h6' component='h2'>
            Hearts
          </Typography>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableHeaderCell>Submission</TableHeaderCell>
                  <TableHeaderCell>No. of Hearts</TableHeaderCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {hearts.map((token) => (
                  <TableRow key={token.submission}>
                    <TableCell>{token.submission}</TableCell>
                    <TableCell>
                      <StyledRatingHearts
                        max={max}
                        value={token.hearts}
                        readOnly
                        icon={<FavoriteIcon fontSize='inherit' />}
                        emptyIcon={<FavoriteBorderIcon fontSize='inherit' />}
                      />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>

        <Box mt={2}>
          <Button fullWidth variant='outlined' onClick={handleClose}>
            Close
          </Button>
        </Box>
      </Box>
    </Dialog>
  );
};

export default HeartsModal;
